var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPalette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1628773797653,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 3605,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M974.769231 340.676923C929.476923 153.6 732.553846 39.384615 515.938462 39.384615 252.061538 39.384615 39.384615 250.092308 39.384615 512s212.676923 472.615385 476.553847 472.615385c366.276923 0 336.738462-185.107692 220.553846-257.969231-68.923077-43.323077-106.338462-143.753846-37.415385-214.646154 128-131.938462 334.769231 78.769231 275.692308-171.323077zM256 669.538462c-55.138462 0-98.461538-43.323077-98.461538-98.461539s43.323077-98.461538 98.461538-98.461538 98.461538 43.323077 98.461538 98.461538-43.323077 98.461538-98.461538 98.461539z m19.692308-374.153847c0-55.138462 43.323077-98.461538 98.461538-98.461538s98.461538 43.323077 98.461539 98.461538-43.323077 98.461538-98.461539 98.461539-98.461538-43.323077-98.461538-98.461539z m216.615384 571.076923c-55.138462 0-98.461538-43.323077-98.461538-98.461538s43.323077-98.461538 98.461538-98.461538 98.461538 43.323077 98.461539 98.461538-43.323077 98.461538-98.461539 98.461538z m177.23077-512c-55.138462 0-98.461538-43.323077-98.461539-98.461538s43.323077-98.461538 98.461539-98.461538 98.461538 43.323077 98.461538 98.461538-43.323077 98.461538-98.461538 98.461538z",
    "p-id": 3606
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalette);
export default __webpack_public_path__ + "static/media/palette.c63a740431bd7e3d94e4163947a91535.svg";
export { ForwardRef as ReactComponent };